import {
  ResponsiveContainer,
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts'

interface Props<T extends Record<string, unknown>> {
  dati: T[]
  chiaveX: keyof T
  chiaveY: keyof T
  colore?: string
  altezza?: number
  formatTooltipY?: (v: number) => string
}

/**
 * Grafico a linea per serie temporali.
 * I colori usano il design token via CSS var() risolta da getComputedStyle.
 */
export function LineChart<T extends Record<string, unknown>>({
  dati,
  chiaveX,
  chiaveY,
  colore,
  altezza = 220,
  formatTooltipY,
}: Props<T>) {
  const tinta = colore ?? leggiVar('--accent', '#6C47FF')
  const griglia = leggiVar('--border', '#E4E4EB')
  const testoSec = leggiVar('--text-secondary', '#6B6B80')
  const surface = leggiVar('--surface', '#fff')

  return (
    <ResponsiveContainer width="100%" height={altezza}>
      <RechartsLineChart data={dati} margin={{ top: 8, right: 12, bottom: 0, left: -10 }}>
        <CartesianGrid stroke={griglia} strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey={chiaveX as string}
          stroke={testoSec}
          fontSize={11}
          tickLine={false}
          axisLine={{ stroke: griglia }}
        />
        <YAxis stroke={testoSec} fontSize={11} tickLine={false} axisLine={false} />
        <Tooltip
          contentStyle={{
            background: surface,
            border: `1px solid ${griglia}`,
            borderRadius: 8,
            fontSize: 13,
          }}
          formatter={(v: number) =>
            formatTooltipY ? formatTooltipY(v) : v
          }
        />
        <Line
          type="monotone"
          dataKey={chiaveY as string}
          stroke={tinta}
          strokeWidth={2}
          dot={{ r: 3, fill: tinta }}
          activeDot={{ r: 5 }}
        />
      </RechartsLineChart>
    </ResponsiveContainer>
  )
}

function leggiVar(nome: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback
  const v = getComputedStyle(document.documentElement).getPropertyValue(nome).trim()
  return v || fallback
}
